var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Graph--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Graph Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph--analytics-business-product-graph-data-chart-analysis"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M1.574 0.898a0.75 0.75 0 0 0 -1.5 0v12.204c0 0.414 0.336 0.75 0.75 0.75h12.204a0.75 0.75 0 1 0 0 -1.5H1.573V0.898Zm8.647 1.533a1 1 0 0 0 -1.413 0.26L5.73 7.307 4.246 5.823A1 1 0 1 0 2.83 7.238l2.347 2.346a1 1 0 0 0 1.54 -0.152l3.181 -4.773 2.446 1.747a1 1 0 0 0 1.162 -1.628l-3.285 -2.347Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.1ab9e9b6b68abda3c0000f535fb3861d.svg";
export { ForwardRef as ReactComponent };